define('libs',[
  './libs/dust.extensions',
  './libs/modernizr.tests',
  'backbone',
  'dustjs-linkedin',
  'dustjs-linkedin-helpers',
  'greensock',
  'greensock-scrollto',
  'hammerjs',
  'jquery.browser',
  'jquery.serializeJSON',
  'jquery-maskedinput',
  'jquery-mousewheel',
  'jquery-placeholder',
  'jquery-ui-datepicker',
  'json',
  'malihu-custom-scrollbar-plugin',
  'parsleyjs',
  'respond',
  'requirejs',
  'select2',
  'underscore'
], function(){

});
